module.exports = __webpack_public_path__ + "static/tyr-DND3_FnP-15520b02295aed018533b3e656894f92.webp";